
export interface ParameterFormField {
  id: string;
  name: string;
  description: string;
  type: string;
  location: string;
  defaultValue?: string; 
  required: boolean;
  isExpanded?: boolean;
  children?: ParameterFormField[];
}

export const updateNodeInTree = (
  nodes: ParameterFormField[],
  id: string,
  updater: (node: ParameterFormField) => ParameterFormField,
): ParameterFormField[] => {
  return nodes.map((node) => {
    if (node.id === id) {
      return updater(node);
    }
    if (node.children) {
      return {
        ...node,
        children: updateNodeInTree(node.children, id, updater),
      };
    }
    return node;
  });
};

export const removeNodeFromTree = (
  nodes: ParameterFormField[],
  id: string,
): ParameterFormField[] => {
  return nodes
    .filter((node) => node.id !== id)
    .map((node) => ({
      ...node,
      children: node.children ? removeNodeFromTree(node.children, id) : undefined,
    }));
};

export const addChildToNode = (
  nodes: ParameterFormField[],
  parentId: string,
  child: ParameterFormField,
): ParameterFormField[] => {
  return nodes.map((node) => {
    if (node.id === parentId) {
      return {
        ...node,
        children: [...(node.children || []), child],
        isExpanded: true,
      };
    }
    if (node.children) {
      return {
        ...node,
        children: addChildToNode(node.children, parentId, child),
      };
    }
    return node;
  });
};
